module.exports = __webpack_public_path__ + "operace-ocnich-vicek-horni_11_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-ocnich-vicek-horni_11_before.jpg
// module id = 1156
// module chunks = 0